export default "__VITE_ASSET__BYx$oUe0__"